<template>
  <div class="local_ocorrencia_sugestao">
    <div class="local_ocorrencia_sugestao_header">
      <IconSvg class="local_ocorrencia_sugestao_icon"
               icon="alert" />
      Existem {{ propListaHospitais.length }} hospitais com esse nome ou similar. Gostaria de utilizar uma dessas opções?
    </div>
    <div class="local_ocorrencia_sugestao_body">
      <b-link @click="toLeft()">
        <IconSvg class="local_ocorrencia_sugestao_iconArrow"
                 icon="arrowLeft" />
      </b-link>
      <div class="local_ocorrencia_sugestao_scroll">
        <div class="d-inline-flex local_ocorrencia_sugestao_cards">
          <div v-for="(hospital, index) in propListaHospitais"
               :id="`card-sugestao-${index}`"
               :key="index"
               class="card_local_sugestao"
               :class="{'card_local_sugestao_disabled': hospitalSelected && hospitalSelected != hospital}">
            <div class="card_local_sugestao_header">
              {{ hospital.nome }}
            </div>
            <div class="card_local_sugestao_body">
              <p class="card_local_sugestao_body_title">
                Endereço 
              </p>
              <p class="card_local_sugestao_body_text">
                {{ `${hospital.endereco.logradouro || ''} ${hospital.endereco.numero ? ', ' + hospital.endereco.numero : ''} ` }} <br>
                {{ hospital.endereco.bairro }}<br>
                {{ `${hospital.endereco.cidade} ${hospital.endereco.uf ? '/' + hospital.endereco.uf : ''}` }} <br>
                {{ hospital.endereco.cep }}<br>
              </p>
              <hr class="hr_footer">
            </div>
            <div class="card_local_sugestao_footer">
              <div class="custom-control custom-switch">
                <input :id="`enderecoHosp-${index}`"
                       class="custom-control-input"
                       name="enderecoHosp"
                       type="checkbox"
                       :checked="hospitalSelected == hospital"
                       :disabled="hospitalSelected && hospitalSelected != hospital"
                       @click="getHospital(hospital)"
                       @keyup.enter="getHospital(hospital)">
                <label class="custom-control-label"
                       :for="`enderecoHosp-${index}`">Utilizar este endereço</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-link @click="toRight()">
        <IconSvg class="local_ocorrencia_sugestao_iconArrow"
                 icon="arrowRight" />
      </b-link>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'LocalOcorrenciaSugestao',
    props: {
      propListaHospitais: {type: Array, default: () => ([])}
    },
    data () {
      return {
        indice: 0,
        valueScrool: 0,
        hospitalSelected: null
      }
    },
    methods: {
      toRight () {
        if (this.indice === this.propListaHospitais.length - 1) return

        const limit = 451 * (this.propListaHospitais.length - 1)
        if (limit === this.valueScrool) return

        this.valueScrool += 451
        this.indice = this.indice + 1

        const scroll = document.querySelector(".local_ocorrencia_sugestao_scroll")
        scroll.scrollTo({left: this.valueScrool, behavior: 'smooth'})
      },
      toLeft () {
        if (this.indice === 0) return

        this.valueScrool -= 451
        this.indice = this.indice - 1
        
        const scroll = document.querySelector(".local_ocorrencia_sugestao_scroll")
        scroll.scrollTo({left: this.valueScrool, behavior: 'smooth'})
      },
      getHospital (hospital) {
        if (this.hospitalSelected == hospital)  {
          this.hospitalSelected = null
        } else {
          this.hospitalSelected = hospital
        }
        this.$emit('changeHospital', this.hospitalSelected)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .local_ocorrencia_sugestao {

    &_header {
      background: #7f7e26;
      color: #FFF;
      padding: 5px 5px 5px 10px;
      margin: 0 0 19px 0px;
    }

    &_body {
      display: flex;
      align-items: center;
    }

    &_icon {
      width: 24px;
      height: 24px;
      fill: #FFF;
    }

    &_iconArrow {
      width: 42px;
      height: 62px;
      min-width: 42px;
    }

    &_scroll {
      overflow: hidden;
      width: 100%;
    }    
  }
  .card_local_sugestao {
    width: 431px;
    border-radius: 2px;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
    margin-right: 20px;

    &_header {
      background: #01aec9;
      font-size: pxToRem(18);
      font-weight: bold;
      padding: 5px;
    }

    &_body{
      background: #FFF;
      
      &_title {
        font-size: pxToRem(14);
        color: #373a3c;
        text-decoration: underline;
        padding: 10px 0 0 10px;
        margin: 0px;
      }

      &_text {
        font-size: pxToRem(16);
        font-weight: 500;
        color: #373a3c;
        padding: 0 0 10px 10px;
        margin: 0;
      }
    }

    &_footer {
      background: #FFF;
      text-align: right;
      padding: 10px;
    }

    &_disabled {
      opacity: 0.5;
    }
  }

  .hr_footer {
    margin: 0;
  }
</style>